import React, { useEffect } from 'react';

import TaskLoader from '../TaskLoader';
import AnnotationPill from '../../AnnotationPill';
import styles from './TaskBox.module.css';

const TaskBox = ({ id, addNewBox, delay, limit, annotation }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (id < limit && delay !== 0) {
        addNewBox(id);
      }
    }, delay);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`${styles.box} flex items-center bg-white w-full h-12 mb-4 pl-4 pr-6 shadow-xl rounded-lg overflow-hidden justify-between box-border`}
      style={{ animationDelay: `${delay - 1900}ms` }}
    >
      <div className="flex items-center shrink-0">
        <AnnotationPill
          icon={annotation.icon}
          name={annotation.name}
          fill="fill-current text-neutral-700"
          task
        />
      </div>
      <div className={`${styles.boxRight} flex items-center justify-end w-full lg:ml-4`}>
        <div className="hidden w-2/3 h-6 bg-neutral-300 rounded-full lg:block" />
        <div className="hidden w-1/3 h-6 ml-2 bg-neutral-300 rounded-full lg:block" />
        <div className="relative shrink-0 w-6 h-6 ml-2">
          <div className="absolute inset-0 flex">
            <TaskLoader delay={delay} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskBox;
